import { Box, Stack, Typography } from '@mui/material';
import * as React from 'react';
import * as JSTool from '../store/JSTool';
import $ from 'jquery';
import NavView from '../component/NavView';
import PageFooter from './PageFooter';
import SectionView from '../component/home/SectionView';
import AboutSectionView from '../component/home/AboutSectionView';
import { useSelector, useDispatch } from 'react-redux';
import { settingActions, settingObj } from '../store/SettingSlice';
import { getImgPath } from '../store/JSTool';
import NavViewMobile from '../mobile/component/NavViewMobile';


export default function AboutUsPage() {

    let navId = 'about_us_page_nav';
    let pageId = 'about_us_page_div';
    let sectionIdAry = ['about_about', 'about_who', 'about_affiliation'];
    const settingData = useSelector(state => state.settingData);


    React.useEffect(() => {
        JSTool.addPageScrollListener(pageId, navId, 0, sectionIdAry);
    }, []);

    return (
        <Stack component={'div'}
            sx={{
                width: 1,
                height: '100vh',
                position: 'relative',
            }}>
            {settingData.isMobile && <NavViewMobile navId={navId} pageId={pageId} />}
            {!settingData.isMobile && <NavView navId={navId} pageId={pageId} />}

            <Stack
                id={pageId}
                component={'div'}
                sx={{
                    width: 1,
                    overflow: 'auto',
                    position: 'relative',
                    alignItems: 'center',
                    minHeight: '100vh',
                }} >

                <Stack sx={{
                    width: 1,
                    bgcolor: 'black'
                }}>
                    <Box
                        component={'img'}
                        src={getImgPath('apj_banner.png')}
                        sx={{
                            opacity: 0.5,
                            width: 1,
                            maxHeight: settingData.isMobile ? '200px' : '300px',
                            minHeight: settingData.isMobile ? '100px' : '150px',
                            objectFit: 'cover',
                        }} />
                </Stack>

                <SectionView id={sectionIdAry[0]} title='About' />
                <AboutSectionView />
                <SectionView id={sectionIdAry[1]} title='Who We Are' />

                <Typography sx={{
                    fontSize: settingData.isMobile ? 22 : 37,
                    fontFamily: settingData.fontFM,
                    my: 1,
                }}>
                    {settingData.langDic['lang16']}
                </Typography>

                <Stack sx={{
                    width: settingData.isMobile ? 1 : '1200px',
                    alignItems: 'center',
                    flexDirection: settingData.isMobile ? 'column' : 'row',
                    justifyContent: 'center',
                }}>
                    <Box component={'img'}
                        src={getImgPath('jp_company.jpg')}
                        sx={{
                            display: 'none',
                            width: settingData.isMobile ? 0.9 : 0.4,
                            borderRadius: '10px',
                            ml: settingData.isMobile ? 0 : 10,
                        }} />

                    <Stack sx={{
                        width: settingData.isMobile ? 1 : 0.42,
                        ml: 5,
                    }}>
                        <AddressItem title={settingData.langDic['lang17']} detail={settingData.langDic['lang18']} />
                        <AddressItem title={settingData.langDic['lang19']} detail={settingData.langDic['lang20']} />
                        <AddressItem title={settingData.langDic['lang21']} detail={settingData.langDic['lang22']} />
                        <AddressItem title={settingData.langDic['lang23']} detail={settingData.langDic['lang24']} />
                        <AddressItem title={settingData.langDic['lang25']} detail={settingData.langDic['lang26']} />
                    </Stack>
                </Stack>

                <AddressMap />

                <SectionView id={sectionIdAry[2]} title='Affiliations' />
                <Stack sx={{
                    flexDirection: settingData.isMobile ? 'column' : 'row',
                    mt: 3,
                }}>
                    <LogoItem index={0} detail="Japan Online Game Association" imgName='joga3.png' />
                    <LogoItem index={1} detail="Computer Entertainment Supplier's Association" imgName='cesa2.png' />
                </Stack>

                <Box sx={{ flex: 1, mt: 3 }} />
                <Box
                    id='apj_logo_id'
                    component={'img'}
                    src={getImgPath('logo_black.png')}
                    sx={{
                        display: !settingData.isMobile && 'none',
                        opacity: 0,
                        mb: 3,
                        width: 0.4,
                    }} />
                <PageFooter pageId={pageId} />
            </Stack>
        </Stack>
    );
}

function LogoItem(props) {

    const settingData = useSelector(state => state.settingData);

    function tap() {
        if (props.index == 0) {
            window.open("https://japanonlinegame.org");
        } else if (props.index == 1) {
            window.open("https://www.cesa.or.jp/index.html");
        }
    }

    return (
        <Stack
            onClick={tap}
            sx={{
                justifyContent: 'center',
                alignItems: 'center',
                mt: 1,
                mb: settingData.isMobile ? 3 : 6,
                cursor: 'pointer',
                mx: 5,
            }}>

            <Box
                component={'img'}
                src={getImgPath(props.imgName)}
                sx={{
                    height: settingData.isMobile ? '40px' : '55px'
                }} />

            <Typography sx={{
                fontSize: settingData.isMobile ? 13 : 17,
                fontFamily: 'Source Han Sans CN',
                mt: 1.5,
            }}>
                ({props.detail})
            </Typography>

        </Stack>
    );
}


function AddressItem(props) {
    const settingData = useSelector(state => state.settingData);

    function tap() {
        if (settingData.langDic['lang25'] == props.title) {
            window.open("https://www.google.com/maps/place/KDX%E8%A5%BF%E6%96%B0%E6%A9%8B%E3%83%93%E3%83%AB/@35.665787,139.7385569,14.71z/data=!3m1!5s0x60188b9493b8cba1:0xbff20aaf923cfa64!4m6!3m5!1s0x60188b18d6dba76b:0xb0dce2fbf788dd82!8m2!3d35.6652115!4d139.7507033!16s%2Fg%2F11q57tpw7m?entry=ttu&g_ep=EgoyMDI0MTEwNS4wIKXMDSoASAFQAw%3D%3D");
        }
    }

    return (
        <Stack
            onClick={tap}
            sx={{
                flexDirection: 'row',
                mt: settingData.isMobile ? 2 : 4,
                cursor: ((settingData.langDic['lang25'] == props.title) && 'pointer')
            }}>
            <Typography sx={{
                width: settingData.isMobile ? '95px' : '135px',
                minWidth: settingData.isMobile ? '95px' : '135px',
                bgcolor: 'black',
                color: 'white',
                textAlign: 'center',
                height: settingData.isMobile ? '30px' : '35px',
                lineHeight: settingData.isMobile ? '30px' : '35px',
                borderRadius: '5px',
                fontFamily: settingData.fontFM,
                fontSize: settingData.isMobile ? 12 : 15,
            }}>
                {props.title}
            </Typography>

            <Typography sx={{
                fontFamily: settingData.fontFM,
                ml: 2,
                mt: 0.5,
                fontSize: settingData.isMobile ? 13 : 17,
            }}>
                {props.detail}
            </Typography>

        </Stack>
    );
}

function AddressMap(props) {
    const settingData = useSelector(state => state.settingData);

    return (
        <Stack sx={{
            width: settingData.isMobile ? 1 : '1200px',
            position: 'relative',
            pb: settingData.isMobile && 18,
        }}>

            <Box component={'img'}
                src={settingData.isMobile ? getImgPath('map_m2.png') : getImgPath('map.png')}
                sx={{
                    width: settingData.isMobile ? '300px' : '650px',
                    minWidth: settingData.isMobile ? '300px' : '650px',
                }} />

            {settingData.isMobile &&
                <Stack>
                    <MapPoint title='TOKYO' top={115} left={250} lineHeight={152} lineWidth={-50} />
                    <MapPoint title='SHANGHAI' top={170} left={145} lineHeight={208} lineWidth={50} />
                    <MapPoint title='SINGAPORE' top={385} left={12} lineHeight={103} />

                    <MapInfo index={0} top={250} lineWidth={-87} title={settingData.langDic['lang16']} detail={settingData.langDic['lang26']} />
                    <MapInfo index={1} top={360} lineWidth={30} title={settingData.langDic['lang27']} detail={settingData.langDic['lang28']} />
                    <MapInfo index={2} top={470} lineWidth={102} title='A PLUS ENTERTAINMENT PTE. LTD.' detail='12 Woodlands Square #10-73 Woods Square, Singapore' />
                </Stack>
            }
            {!settingData.isMobile &&
                <Stack>
                    <MapPoint title='TOKYO' top={185} left={590} lineHeight={35} />
                    <MapPoint title='SHANGHAI' top={255} left={455} lineHeight={95} />
                    <MapPoint title='SINGAPORE' top={514} left={280} lineHeight={40} isUp={true} />

                    <MapInfo index={0} top={200} lineWidth={84} title={settingData.langDic['lang16']} detail={settingData.langDic['lang26']} />
                    <MapInfo index={1} top={330} lineWidth={205} title={settingData.langDic['lang27']} detail={settingData.langDic['lang28']} />
                    <MapInfo index={2} top={460} lineWidth={375} title='A PLUS ENTERTAINMENT PTE. LTD.' detail='12 Woodlands Square #10-73 Woods Square, Singapore' />
                </Stack>
            }
        </Stack>
    );
}

function MapPoint(props) {
    const settingData = useSelector(state => state.settingData);

    return (
        <Stack sx={{
            position: 'absolute',
            alignItems: 'center',
            zIndex: 2,
            top: `${props.top}px`,
            left: `${props.left}px`,
            flexDirection: props.isUp ? 'column-reverse' : 'column',
        }}>
            <Typography sx={{
                fontWeight: 'bold',
                fontSize: settingData.isMobile ? 12 : 15,
            }}>
                {props.title}
            </Typography>

            <Box
                sx={{
                    bgcolor: '#FFA028',
                    width: '10px',
                    height: '10px',
                    borderRadius: '5px',
                    zIndex: 3,
                }} />

            <Box sx={{
                width: '1px',
                height: `${props.lineHeight}px`,
                bgcolor: 'black',
                position: settingData.isMobile && 'absolute',
                top: settingData.isMobile && '23px',
                left: settingData.isMobile && (props.lineWidth > 0 ? `${-Math.abs(props.lineWidth) * 0.48}px` : `${Math.abs(props.lineWidth) * 1.5 + 2}px`),
            }} />

            <Box sx={{
                width: `${Math.abs(props.lineWidth)}px`,
                height: '1px',
                bgcolor: 'black',
                position: 'absolute',
                top: '23px',
                zIndex: 2,
                left: props.lineWidth > 0 ? `-${props.lineWidth / 2 - 2}px` : `${Math.abs(props.lineWidth) * 0.5 + 3}px`,
            }} />

        </Stack>
    );
}

function MapInfo(props) {

    const settingData = useSelector(state => state.settingData);

    function tap() {
        if (props.index == 0) {
            window.open("https://www.google.com/maps/place/KDX%E8%A5%BF%E6%96%B0%E6%A9%8B%E3%83%93%E3%83%AB/@35.665787,139.7385569,14.71z/data=!3m1!5s0x60188b9493b8cba1:0xbff20aaf923cfa64!4m6!3m5!1s0x60188b18d6dba76b:0xb0dce2fbf788dd82!8m2!3d35.6652115!4d139.7507033!16s%2Fg%2F11q57tpw7m?entry=ttu&g_ep=EgoyMDI0MTEwNS4wIKXMDSoASAFQAw%3D%3D");

        } else if (props.index == 1) {
            window.open("https://www.google.com/maps/place/%E5%85%AD%E5%85%AB%E5%85%AB%E5%B9%BF%E5%9C%BA/@31.2316007,121.4620626,17z/data=!4m6!3m5!1s0x35b270144600a3bd:0xdaaa2d264d0d8610!8m2!3d31.231408!4d121.464541!16s%2Fg%2F11cm1j6fw7?entry=ttu");

        } else if (props.index == 2) {
            window.open("https://www.google.com/maps/place/Woodlands+Square,+%E6%96%B0%E5%8A%A0%E5%9D%A1/@1.4383392,103.7643638,14z/data=!4m6!3m5!1s0x31da13a8888377d1:0xdd95aae21ea2565f!8m2!3d1.4364417!4d103.7849068!16s%2Fg%2F1td0qd7m?entry=ttu");
        }
    }

    return (
        <Stack
            onClick={tap}
            sx={{
                position: 'absolute',
                zIndex: 2,
                top: `${props.top}px`,
                left: settingData.isMobile ? '150px' : '700px',
                cursor: 'pointer',
            }}>

            <Typography sx={{
                fontSize: settingData.isMobile ? 14 : 22,
                fontFamily: settingData.fontFM,
            }}>
                {props.title}
            </Typography>

            {/* 右边 */}
            <Stack sx={{
                flexDirection: settingData.isMobile ? 'column' : 'row',
                mt: 1,
                width: settingData.isMobile ? 'auto' : '550px',
            }}>
                <Typography sx={{
                    width: settingData.isMobile ? '90px' : '120px',
                    minWidth: settingData.isMobile ? '90px' : '120px',
                    bgcolor: '#FFC714',
                    color: 'white',
                    textAlign: 'center',
                    height: settingData.isMobile ? '20px' : '25px',
                    lineHeight: settingData.isMobile ? '20px' : '25px',
                    borderRadius: '4px',
                    fontFamily: 'Lexend Deca',
                    fontSize: settingData.isMobile ? 11 : 13
                }}>
                    Location
                </Typography>


                <Typography sx={{
                    fontFamily: settingData.fontFM,
                    ml: !settingData.isMobile && 2,
                    fontSize: settingData.isMobile ? 11 : 13,
                    mt: settingData.isMobile && 1,
                }}>
                    {props.detail}
                </Typography>
            </Stack>

            <Box sx={{
                width: `${Math.abs(props.lineWidth)}px`,
                height: '1px',
                bgcolor: 'black',
                position: 'absolute',
                top: settingData.isMobile ? '40px' : '53px',
                left: props.lineWidth > 0 ? `-${props.lineWidth}px` : `90px`,
            }} />

        </Stack>
    );
}